import React from 'react';
import { useTheme } from '@mui/material/styles';
import type { ThemedSvgProps } from '../../types';

interface PoolBallProps extends ThemedSvgProps {
  number?: number;
}

const PoolBallBase: React.FC<PoolBallProps> = ({ color, size = 60, number = 6, className }) => {
  const theme = useTheme();
  const fill = color || theme.palette.venue.snooker;
  const clipId = `pool-ball-clip-${number}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={className}
    >
      <defs>
        <clipPath id={clipId}>
          <circle cx="50" cy="50" r="40" />
        </clipPath>
      </defs>

      {/* Ball body */}
      <circle cx="50" cy="50" r="40" fill={fill} />

      {/* White stripe band across middle */}
      <rect x="10" y="38" width="80" height="24" rx="0" fill="white" clipPath={`url(#${clipId})`} />

      {/* Number circle background */}
      <circle cx="50" cy="50" r="12" fill="white" />

      {/* Number text */}
      <text
        x="50"
        y="50"
        textAnchor="middle"
        dominantBaseline="central"
        fill={fill}
        fontSize="14"
        fontWeight="700"
        fontFamily="sans-serif"
      >
        {number}
      </text>

      {/* Radial shine highlight */}
      <circle cx="36" cy="36" r="10" fill="white" opacity={0.3} />
    </svg>
  );
};

export const PoolBall = React.memo(PoolBallBase);
